<template>
  <v-container>
    <v-container class="edit-profile-container">
      <change-profile-info-form />
      <change-password-form />
    </v-container>
  </v-container>
</template>

<script>
import ChangeProfileInfoForm from "@/views/user/ChangeProfileInfoForm.vue";
import ChangePasswordForm from "@/views/user/ChangePasswordForm.vue";

export default {
  metaInfo() {
    return {
      title: this.$t('routes.editUserProfile'),
    }
  },
  components: {
    ChangeProfileInfoForm,
    ChangePasswordForm,
  },
};
</script>

<style scoped>
.edit-profile-container {
  background-color: var(--v-lightestAccent-base);
}
</style>
